import { useAppPageLayout } from '../useAppPageLayout'
import { useGetAppPage } from '../useGetAppPage'
import { PageHeader } from '@/components/ui/PageHeader'
import { useIsPageBuilder } from '@/catalog-apps/hooks/useIsPageBuilder'

export function CatalogPageHeader({
  children,
  titleAction,
}: {
  children?: React.ReactNode
  titleAction?: React.ReactNode
}) {
  const isPageBuilder = useIsPageBuilder()
  const { titleDesrcription } = useAppPageLayout()
  const {
    data: { title, description, pageFilters, emphasizeHeader },
  } = useGetAppPage()
  const { title: pbTitle, description: pbDescription } = titleDesrcription
  const currentTitle = isPageBuilder ? pbTitle : title
  const currentDescription = isPageBuilder ? pbDescription : description
  if (!title && !pageFilters.length) {
    return null
  }
  return (
    <PageHeader
      title={currentTitle}
      description={currentDescription}
      titleAction={titleAction}
      emphasized={emphasizeHeader}
    >
      {children}
    </PageHeader>
  )
}
